module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yo-scroll",
    class: {
      'down': (_vm.state === 0), 'up': (_vm.state == 1), refresh: (_vm.state === 2), touch: _vm.touching, finish: (_vm.state === 3)
    },
    on: {
      "touchstart": function($event) {
        _vm.touchStart($event)
      },
      "touchmove": function($event) {
        _vm.touchMove($event)
      },
      "touchend": function($event) {
        _vm.touchEnd($event)
      },
      "scroll": function($event) {
        (_vm.onInfinite || _vm.infiniteLoading) ? _vm.onScroll($event): undefined
      }
    }
  }, [_c('div', {
    staticClass: "inner",
    style: ({
      transform: 'translate3d(0, ' + _vm.top + 'px, 0)'
    })
  }, [_c('header', {
    staticClass: "pull-refresh"
  }, [_vm._t("pull-refresh", [_c('span', {
    staticClass: "down-tip"
  }, [_vm._v("下拉刷新")]), _vm._v(" "), _c('span', {
    staticClass: "up-tip"
  }, [_vm._v("松开更新")]), _vm._v(" "), _c('span', {
    staticClass: "refresh-tip"
  }, [_vm._v("正在更新中")]), _vm._v(" "), _c('span', {
    staticClass: "finish-tip"
  }, [_vm._v("更新完成")])])], 2), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('footer', {
    staticClass: "load-more"
  }, [_vm._t("load-more", [_c('span', [_vm._v(_vm._s(_vm.loadingText))])])], 2)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bedf7fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PullRefresh.vue
// module id = 315
// module chunks = 1